export const costs = [
  'Noches en vela buscando cómo traducir conceptos topográficos complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la topografía no tiene nada que ver con ellos ni con su carrera.',
  'Silencios incómodos cuando un alumno pregunta cómo se mide un desnivel con un nivel y no tenés una respuesta visual clara a mano.',
  'Fines de semana perdidos armando planificaciones, prácticas de campo y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar QGIS, drones y fotogrametría sin los recursos adecuados.',
];
